import _defineProperty from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import SPACINGS_AFTER from "./consts";

var getSpacingToken = function getSpacingToken(_ref) {
  var _tokens;

  var spaceAfter = _ref.spaceAfter,
      theme = _ref.theme;
  var tokens = (_tokens = {}, _defineProperty(_tokens, SPACINGS_AFTER.NONE, "0"), _defineProperty(_tokens, SPACINGS_AFTER.SMALLEST, theme.orbit.spaceXXSmall), _defineProperty(_tokens, SPACINGS_AFTER.SMALL, theme.orbit.spaceXSmall), _defineProperty(_tokens, SPACINGS_AFTER.NORMAL, theme.orbit.spaceSmall), _defineProperty(_tokens, SPACINGS_AFTER.MEDIUM, theme.orbit.spaceMedium), _defineProperty(_tokens, SPACINGS_AFTER.LARGE, theme.orbit.spaceLarge), _defineProperty(_tokens, SPACINGS_AFTER.LARGEST, theme.orbit.spaceXLarge), _tokens);
  return spaceAfter && tokens[spaceAfter];
};

export default getSpacingToken;